import { createSlice } from '@reduxjs/toolkit';
import { fetchDeliveryReceiptDocumentThunk } from '@data/actions/deliverReceiptDocumentActions.ts';

export interface DeliveryReceiptDocumentInitialState {
  isLoading: boolean;
  error: string | null;
  document: string | null;
}
const initialState: DeliveryReceiptDocumentInitialState = {
  error: null,
  isLoading: false,
  document: null,
};

const deliveryReceiptDocumentSlice = createSlice({
  name: 'deliveryReceiptDocument',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.isLoading = Boolean(action.payload);
    },
    resetDeliveryReceiptDocument: () => initialState,
  },
  extraReducers: builder => {
    builder.addCase(fetchDeliveryReceiptDocumentThunk.pending, state => {
      state.isLoading = true;
      state.document = null;
    });
    builder.addCase(
      fetchDeliveryReceiptDocumentThunk.fulfilled,
      (state, action) => {
        state.document = action.payload;
        state.isLoading = false;
      }
    );
    builder.addCase(
      fetchDeliveryReceiptDocumentThunk.rejected,
      (state, action) => {
        state.isLoading = false;
        state.error = action.error.message || null;
        state.document = null;
      }
    );
  },
});

export const deliveryReceiptDocumentReducer =
  deliveryReceiptDocumentSlice.reducer;

export const { resetDeliveryReceiptDocument } =
  deliveryReceiptDocumentSlice.actions;
